module.exports = __webpack_public_path__ + "img/4.8ecf73aa.png";